import { getStaticImageUrl } from '@utils/createImageUrl';

const ThirtyFiveDay = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <>
      <img
        alt="의뢰인 방문상담 3시간 전 알림"
        className="for-lawyer-advice-before-three-hour-noti view-on-visible"
        src={getStaticImageUrl({ fileName: 'preview/mobile-visit-advice-noti.png' })}
      />
      <div className="for-lawyer-dayplus-title-container">
        <div className="for-lawyer-dayplus-title view-on-visible">
          <h2 className="for-lawyer-day-title white">Day</h2>
          <span className="for-lawyer-day-plus-number-title">+35</span>
        </div>
        {isMobile ? (
          <p className="for-lawyer-day-desc white view-on-visible">
            연고가 없는 지역에 개업한지라 걱정이
            <br />
            많았는데, 지난번에 구매한 지역 광고를 보고
            <br />
            <span className="for-lawyer-day-desc-bold">의뢰인이 방문해 상담</span>을 진행했다. <br />
            <br />
            소송이 꼭 필요한 사건이라 착수금 관련 안내를 하고 상담을 마무리했다.
          </p>
        ) : (
          <p className="for-lawyer-day-desc white view-on-visible">
            연고가 없는 지역에 개업한지라 걱정이 많았는데, 지난번에 구매한
            <br />
            지역 광고를 보고 의뢰인이 방문해 상담을 진행했다. <br />
            <br />
            소송이 꼭 필요한 사건이라 착수금 관련 안내를 하고
            <br />
            상담을 마무리했다.
          </p>
        )}
      </div>
    </>
  );
};

export default ThirtyFiveDay;
